/*
 * Copyright (C) 2026 AB Volvo
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../../../store/Types";
import { ThemeProvider } from "@volvo/vcdk/theme-provider";
const SLICE_NAME = "navigation";

type ThemeId = Exclude<ThemeProvider["themeId"], undefined>;

type NavigationBarState = {
  menuOpen: boolean;
  themeId: ThemeId;
};

export const initialNavigationBarState: NavigationBarState = {
  menuOpen: false,
  themeId: "volvo-light", // "renault-dark",
};

const navigationBarSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialNavigationBarState,
  reducers: {
    toggleMenu: (state, { payload: menuOpened }: PayloadAction<boolean>) => {
      state.menuOpen = menuOpened;
    },
    toggleTheme: (state, { payload: themeId }: PayloadAction<ThemeId>) => {
      state.themeId = themeId;
    },
  },
});

export const { toggleMenu, toggleTheme } = navigationBarSlice.actions;
export const selectMenuOpen = (state: RootState) =>
  state.navigationBar.menuOpen;
export const selectThemeId = (state: RootState) => state.navigationBar.themeId;

export default navigationBarSlice.reducer;
